/**
 * Address Utility Functions
 * @see mobile: module-customer/src/modules/addresses/utils/
 */

import type { CustomerAddress, CustomerAddressRegion, Maybe } from '../../../types';

// Re-export location fields utilities
export * from './location-fields-form.utils';

// Re-export create/update address utilities
export * from './create-update-address-form.utils';

// Re-export address selection utilities
export * from './address-selection.utils';

export * from './regions-directory.utils';

export * from './districts-directory.utils';

export * from './wards-directory.utils';
/**
 * Get region name from address (handles both string and CustomerAddressRegion object)
 */
const getRegionName = (region: Maybe<string> | Maybe<CustomerAddressRegion> | undefined): string | undefined => {
    if (!region) return undefined;
    if (typeof region === 'string') return region;
    return region.region ?? undefined;
};

/**
 * Format address to full string
 */
export const formatFullAddress = (address: CustomerAddress): string => {
    const parts = [
        address.street?.join(', '),
        address.ward,
        address.district,
        address.city,
        getRegionName(address.region),
    ].filter(Boolean);
    return parts.join(', ');
};

/**
 * Get customer full name from address
 */
export const getCustomerName = (address: CustomerAddress): string => {
    return `${address.firstname ?? ''} ${address.lastname ?? ''}`.trim() || 'Không có tên';
};
